import { useMutation } from '@tanstack/react-query';
import { PromotionsService } from '../services';

// Report download is imperative (returns a blob), so it's modelled as a
// mutation. The caller's onSuccess receives { blob, filename } and is
// responsible for saving the file to disk.
export const useDownloadPayoutReport = (options = {}) => {
  const { onSuccess, onError } = options;

  return useMutation({
    meta: { skipGlobalErrorToaster: true },
    mutationFn: (params) => PromotionsService.downloadPayoutReport(params),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
